import React from 'react';

const AdvertisementTicker = ({ ads }) => {
    if (!ads || ads.length === 0) return null;

    const STORAGE_URL = window.location.hostname === 'localhost'
        ? 'http://localhost:8000'
        : 'https://api.goodbuytamizha.com';

    return (
        <div className="bg-transparent overflow-hidden py-1 relative">
            <div className="flex whitespace-nowrap animate-marquee hover:[animation-play-state:paused] items-center">
                {/* Repeat ads to ensure continuous flow */}
                {[...ads, ...ads, ...ads].map((ad, index) => {
                    const Content = () => (
                        <div className="mx-8 flex items-center justify-center p-4 rounded-xl hover:bg-white/50 transition-colors backdrop-blur-sm">
                            {ad.image_path ? (
                                <img
                                    src={`${STORAGE_URL}${ad.image_path}`}
                                    alt={ad.title || "Advertisement"}
                                    className="h-20 w-auto object-contain max-w-[180px] drop-shadow-sm hover:scale-105 transition-transform duration-300"
                                />
                            ) : (
                                <span className="text-slate-700 font-medium text-lg px-6 py-3 border border-dashed border-slate-300 rounded-lg bg-white/50">
                                    {ad.content}
                                </span>
                            )}
                        </div>
                    );

                    return (
                        ad.link ? (
                            <a
                                key={`${ad.id}-${index}`}
                                href={ad.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="block focus:outline-none"
                            >
                                <Content />
                            </a>
                        ) : (
                            <div key={`${ad.id}-${index}`}>
                                <Content />
                            </div>
                        )
                    );
                })}
            </div>
            <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 50s linear infinite; /* Slower for premium feel */
        }
      `}</style>
        </div>
    );
};

export default AdvertisementTicker;
